import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class AgreementsDocumentFile extends BaseModel {
  static override constructorName = 'AgreementsDocumentFile'

  id: number = 0
  name: string = ''
  fileName: string = ''
  mimeType: string = ''
  source: string = ''

  constructor(data?: unknown) {
    super(data)

    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(AgreementsDocumentFile)
